import { GetStaticPropsContext, NextPage } from 'next'

import { useTranslation } from 'next-i18next'

import Metatags from '~/components/Metadata/Metatags'

import { getBootcampCategoriesData } from '~/../utils/data-fetch/bootcamp/bootcamp.query'
import { AppLanguage } from '~/types/locale'
import getTopicList from '~/bootcamp/utils/getTopicList.utils'
import { VideoTopic } from '~/types/bootcamp'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import VideoTopicList from '~/bootcamp/pages/VideoTopicList/VideoTopicList'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'

const BootcampCategoriesNextPage: NextPage<{ topicListData: VideoTopic[] }> = ({ topicListData }) => {
  const { t } = useTranslation('bootcamp')
  const pageTitle = t('title')

  return (
    <DefaultLayout>
      <Metatags metaDescription={t('metaDescriptionBootcampCategory')} title={pageTitle} />
      <VideoTopicList topicListData={topicListData} />
    </DefaultLayout>
  )
}

export const getProps: GetProps =
  () =>
  async ({ locale }: GetStaticPropsContext) => {
    const [categoriesSanityData, enCategoriesSanityData] = await Promise.all([
      getBootcampCategoriesData(locale as AppLanguage),
      locale !== AppLanguage.EN ? getBootcampCategoriesData(AppLanguage.EN) : undefined,
    ])

    const topicListData = getTopicList(
      categoriesSanityData,
      enCategoriesSanityData || categoriesSanityData,
      locale as AppLanguage,
    )

    return {
      props: {
        namespaces: ['bootcamp', ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES],
        topicListData,
      },
      revalidate: process.env.ENVIRONMENT === 'staging' ? 3600 : false,
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)

export default BootcampCategoriesNextPage
